import {medicineReferences} from "../../hooks/medicineReferences.mjs";
import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import {
  AppBar,
  IconButton,
  Slide,
  Toolbar,
  Typography,
  Grid,
  Alert,
} from "@mui/material";

// Icons
import CloseIcon from "@mui/icons-material/Close";

import { useDispatch, useSelector } from "react-redux";
import { getMedCategories } from "../../reduxToolkit/features/adminPanel/medicine";
import { getCompareList } from "../../reduxToolkit/features/frontend/compare";
import LoadingBox from "../misc/Loading";
import ProductLarge from "../product/ProductLarge";
import { mergeMedicineList } from "../../hooks/mergeMedicineList";
import { colors, fonts } from "../../theme/designTokens";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

export default function CompareDlg({ compareOpen, setCompareOpen, lang }) {
  // use State
  //   const [catListLoading, setCatListLoading] = useState(false);
  const [catList, setCatList] = useState([]);
  const [medLoading, setMedLoading] = useState(false);
  const [medList, setMedList] = useState([]);

  // store
  const { medicines, categories } = useSelector((state) => state.medicine);
  const { compareList } = useSelector((state) => state.compare);

  const handleCompareDlgClose = () => {
    setCompareOpen(false);
  };

  // Use Effect
  const dispatch = useDispatch();
  useEffect(() => {
    // if (!(medicines && medicines.length > 0)) dispatch(getMedicines());
    if (!(categories && categories.length > 0)) dispatch(getMedCategories());
    if (!(compareList && compareList.length > 0)) dispatch(getCompareList());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //   set medicines
  useEffect(() => {
    setMedLoading(true);
    if (
      lang !== "" &&
      medicines &&
      medicines.length > 0 &&
      compareList &&
      compareList.length > 0
    ) {
      const mergedData = mergeMedicineList(medicines, lang);
      if (mergedData.length > 0) {
        let arr = [...mergedData];
        let arr2 = [];
        compareList.forEach((x) => {
          const A = arr.find(
            (a) =>
              (lang !== "en" ? a.medicineDetectorId : a.fixedMedicineId) === x
          );
          if (A) arr2.push(A);
        });

        setMedList(arr2);
      } else {
        setMedList([]);
      }
    }
    setTimeout(() => {
      setMedLoading(false);
    }, 1000);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [compareList, medicines, lang]);

  // set Category
  useEffect(() => {
    if (lang !== "" && categories && categories.length > 0) {
      const C = {data: medicineReferences(categories, lang, "category")};
      if (C) setCatList(C.data);
      else setCatList([]);
    }
  }, [categories, lang]);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate

  return (
    <Dialog
      open={compareOpen}
      onClose={handleCompareDlgClose}
      aria-labelledby={"compare"}
      TransitionComponent={Transition}
      fullScreen
      PaperProps={{ sx: { bgcolor: colors.paper } }}
    >
      <AppBar
        sx={{
          position: "sticky",
          bgcolor: colors.paperTint,
          borderBottom: `1px solid ${colors.line}`,
          boxShadow: "none",
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            onClick={handleCompareDlgClose}
            aria-label="close"
            sx={{ color: colors.ink2 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography
            sx={{ ml: 2, flex: 1, fontFamily: fonts.display, fontWeight: 800, color: colors.ink }}
            variant="h6"
          >
            {translateFront("Comparison")}
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent sx={{ bgcolor: colors.paper }}>
        <Grid container spacing={2}>
          {medLoading ? (
            <LoadingBox w={"100%"} />
          ) : medList.length < 1 ? (
            <Grid item xs={12}>
              <Alert severity="warning" fullWidth>
                {translateFront("Nothing To Compare...")}
              </Alert>
            </Grid>
          ) : (
            medList.map((x, i) => (
              <Grid item key={i} xs={12} sm={6} md={4} xl={3}>
                <ProductLarge
                  x={x}
                  i={i}
                  view={0}
                  catList={catList}
                  lang={lang}
                  setCompareOpen={setCompareOpen}
                />
              </Grid>
            ))
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
